/**
 * Report sections by product (Jaron, Oct 30, 13433630544: "Smart Home shows up
 * for a second when going in to the customer report").
 *
 * An empty `products` means "everything" on a legacy deal, but it is also what
 * every customer has until its first batch arrives (500 ms debounce in the
 * single-customer channel). So a Roof-Claim-only report painted the Smart Home
 * line-up first and then removed it. The sections now wait until an empty
 * `products` is known to be really empty.
 *
 * On a read error or after the timeout (V45) the report behaves as it did
 * before this change instead of staying incomplete.
 */
export const PRODUCTS_LOAD_TIMEOUT_MS = 5000

export interface ProductsConfirmation {
  customerID: string
  status: 'error' | 'loading' | 'ready'
  value: string
}

export const reportProductsResolved = (
  customerID: string,
  confirmation: ProductsConfirmation,
  timedOut: boolean,
): boolean =>
  timedOut ||
  (confirmation.customerID === customerID &&
    (confirmation.status === 'error' ||
      (confirmation.status === 'ready' && !confirmation.value)))

export const inReportScope = (
  products: readonly string[],
  product: string,
  resolved: boolean,
): boolean => products.includes(product) || (products.length === 0 && resolved)
